import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import './PhotoGalleryByDate.css';

const PhotoGalleryByDate = () => {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [receipts, setReceipts] = useState([]);
  const [newMarks, setNewMarks] = useState({});
  const [markStatus, setMarkStatus] = useState({});

  const formatDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-');
    return `${d}-${m}-${y.slice(-2)}`;
  };

  useEffect(() => {
  const today = new Date().toISOString().split('T')[0];
  setDateFrom(today);
  setDateTo(today);
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dateFrom || !dateTo) return;

    setLoading(true);
    setError('');
    setReceipts([]);

    const from = formatDate(dateFrom);
    const to = formatDate(dateTo);

    try {
      const fileGroups = await api.get(`/upload/files/range?from=${from}&to=${to}`);

      const photos = [];
      fileGroups.forEach(({ date, files }) => {
        files.forEach(file => {
          const match = file.match(/-(\d+)-\d+\.png$/);
          const receiptId = match ? match[1] : null;
          if (receiptId) {
            photos.push({ receiptId, file, date });
          }
        });
      });

      const grouped = {};
      photos.forEach(({ receiptId, file, date }) => {
        if (!grouped[receiptId]) grouped[receiptId] = { photos: [], date };
        grouped[receiptId].photos.push(file);
      });

      const receiptIds = Object.keys(grouped);
      const responses = await Promise.all(
        receiptIds.map(async (id) => {
          try {
            const r = await api.get(`/receipts/${id}`);
            return { ...r, id, photos: grouped[id].photos, date: grouped[id].date };
          } catch {
            return null;
          }
        })
      );

      setReceipts(responses.filter(Boolean));
    } catch {
      setError('Ошибка при получении данных.');
    } finally {
      setLoading(false);
    }
  };
  


const handleAddMark = async (productId, fileName) => {
  const key = `${productId}_${fileName}`;
  const mark = newMarks[key]?.trim();
  if (!mark) {
    setMarkStatus(prev => ({ ...prev, [key]: '⚠️ Введите марку' }));
    return;
  }

  try {
    await api.post(`/products/${productId}/marks`, { marks: [mark] });
    setNewMarks(prev => ({ ...prev, [key]: '' }));
    setMarkStatus(prev => ({ ...prev, [key]: '✅ Марка добавлена' }));

    // Обновим локально список марок
    setReceipts(prev =>
      prev.map(r => ({
        ...r,
        products: r.products.map(p =>
          p.id === productId
            ? { ...p, marks: [...(p.marks || []), mark] }
            : p
        )
      }))
    );
  } catch (err) {
    const message = err.response?.data?.error || '❌ Ошибка добавления марки';
    setMarkStatus(prev => ({ ...prev, [key]: message }));
  }
};

const handleDeleteMark = async (productId, fileName, markIndex) => {
  const key = `${productId}_${fileName}`;
  try {
    await api.delete(`/products/${productId}/marks/${markIndex}`);
    setReceipts(prev =>
      prev.map(r => ({
        ...r,
        products: r.products.map(p =>
          p.id === productId
            ? { ...p, marks: p.marks.filter((_, i) => i !== markIndex) }
            : p
        )
      }))
    );
    setMarkStatus(prev => ({ ...prev, [key]: '✅ Марка удалена' }));
  } catch (err) {
    const message = err.response?.data?.error || '❌ Ошибка удаления марки';
    setMarkStatus(prev => ({ ...prev, [key]: message }));
  }
};


  return (
    <div className="photo-page-container">
      <h1 className="PhotoTitle">Квитанции с фото</h1>

      <form onSubmit={handleSubmit} className="PhotoForm">
        <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} required />
        <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} required />
        <button type="submit">Найти</button>
      </form>

      {loading && <p>Загрузка...</p>}
      {error && <p className="PhotoError">{error}</p>}

      <div className="PhotoCardContainer">
        {receipts.map(receipt => (
          <div key={receipt.id} className="PhotoCard">
          <h2>Квитанция {receipt.receipt_number} |id {receipt.id},</h2>
          <p><b>Дата:</b> {receipt.date}</p>
          <p><b>Клиент:</b> {receipt.client_name}</p>
          <p><b>Адрес:</b> {receipt.delivery_address}</p>
          <p><b>Оплата:</b> {receipt.payment_method}</p>

          <h4>Товары:</h4>
          <ul>
            {receipt.products?.map(p => (
              <li key={p.id}>
                <b>{p.product_name}</b> — {p.actual_quantity} шт.
                <div className="PhotoMarks">
                  {p.marks?.map((mark, idx) => (
                    <div key={idx} className="PhotoMarkItem">
                      <span>{mark}</span>
                      <button onClick={() => handleDeleteMark(p.id, receipt.photos[0], idx)}>Удалить</button>
                    </div>
                  ))}
                  <div className="PhotoAddMark">
                    <input
                      placeholder="Новая марка"
                      value={newMarks[`${p.id}_${receipt.photos[0]}`] || ''}
                      onChange={(e) =>
                        setNewMarks(prev => ({ ...prev, [`${p.id}_${receipt.photos[0]}`]: e.target.value }))
                      }
                    />
                    <button onClick={() => handleAddMark(p.id, receipt.photos[0])}>Добавить</button>
                  </div>

                  {markStatus[`${p.id}_${receipt.photos[0]}`] && (
                    <p className="PhotoMarkStatus">
                      {markStatus[`${p.id}_${receipt.photos[0]}`]}
                    </p>
                  )}
                </div>
              </li>
            ))}
          </ul>

          <div className="PhotoGallery">
            {receipt.photos.map((file, idx) => (
              <img
                key={idx}
                src={`${api.defaults.baseURL}/upload/images/${receipt.date}/${file}`}
                alt={file}
              />
            ))}
          </div>

          {markStatus[receipt.photos[0]] && (
            <p className="PhotoMarkStatus">{markStatus[receipt.photos[0]]}</p>
          )}
        </div>
      ))}
    </div>
    </div>
  );
};

export default PhotoGalleryByDate;
